import { createTheme } from "@mui/material/styles";
const { palette } = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#0F172A",
            light: "#334155",
            dark: "#020617",
        },
        secondary: {
            main: "#FBBF24",
            light: "#FDE68A",
            dark: "#F59E0B",
        },
        warning: {
            main: "#F97316",
        },
        background: {
            default: "#0F172A",
            paper: "#1E293B",
        },
        text: {
            primary: "#FFFFFF",
            secondary: "#E2E8F0",
        },
    },
});
const typography = {
    fontFamily: "'Jost', sans-serif",
    h1: {
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "clamp(3rem, 7vw, 6rem)",
        fontWeight: 500,
        lineHeight: 0.95,
        letterSpacing: "-0.02em",
        color: "#2B241E",
    },
    h2: {
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
        fontWeight: 500,
        lineHeight: 1,
        letterSpacing: "-0.015em",
    },
    h3: {
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "clamp(2rem, 4vw, 3.25rem)",
        fontWeight: 500,
        lineHeight: 1.05,
    },
    h4: {
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "2.25rem",
        fontWeight: 500,
        lineHeight: 1.1,
    },
    h5: {
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "1.75rem",
        fontWeight: 500,
        lineHeight: 1.15,
    },
    h6: {
        fontFamily: "'Jost', sans-serif",
        fontSize: "1rem",
        fontWeight: 500,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
    },
    body1: {
        fontFamily: "'Jost', sans-serif",
        fontSize: "1rem",
        lineHeight: 1.7,
        color: "#2B241E",
    },
    body2: {
        fontFamily: "'Jost', sans-serif",
        fontSize: "0.9rem",
        lineHeight: 1.6,
        color: "#766B60",
    },
    subtitle1: {
        fontFamily: "'Jost', sans-serif",
        fontSize: "1.05rem",
        fontWeight: 400,
        lineHeight: 1.5,
    },
    button: {
        fontFamily: "'Jost', sans-serif",
        fontSize: "0.8rem",
        fontWeight: 500,
        letterSpacing: "0.1em",
        textTransform: "uppercase",
    },
    caption: {
        fontFamily: "'Jost', sans-serif",
        fontSize: "0.75rem",
        letterSpacing: "0.08em",
        color: "#8A7E70",
    },
};
export const BASE_THEME = createTheme({
    palette,
    typography,
    components: {
        MuiTextField: {
            defaultProps: { color: "secondary" },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    "&:last-child": {
                        paddingBottom: 16,
                    },
                },
            },
        },
        MuiButton: {
            defaultProps: {
                color: "secondary",
            },
        },
        MuiTabs: {
            defaultProps: {
                textColor: "secondary",
                indicatorColor: "secondary",
            },
        },
    },
});
export const CASTORO_THEME = createTheme({
    ...BASE_THEME,
    typography: { ...typography, fontFamily: "'Castoro', sans-serif" },
});
export const PALETTE = BASE_THEME.palette;
export const TYPOGRAPHY = BASE_THEME.typography;
